import { Keyboard } from '@capacitor/keyboard'
import { useEffect, useState } from 'react'

import CapacitorService from '../services/CapacitorService'

type HookType = {
  visible: boolean
}
export const useAppKeyboard = (): HookType => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (CapacitorService.isNative() && CapacitorService.isPluginAvailable('Keyboard')) {
      Keyboard.addListener('keyboardWillShow', () => {
        setVisible(true)
      })

      Keyboard.addListener('keyboardWillHide', () => {
        setVisible(false)
      })

      return () => {
        Keyboard.removeAllListeners()
      }
    }
  }, [])

  return { visible }
}
